import React from 'react';

import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {isTeammateNamespace} from '../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {StyledLockIconWrapper} from './settingsSearchCommon';
import {SettingsSearchDropdownTeamAccessory} from './settingsSearchDropdownTeamAccessory';

export function maybeRenderAccessory(resourceWithNamespace: {namespace: string}, team?: TeamModel) {
  if (isTeammateNamespace(resourceWithNamespace.namespace)) {
    return (
      <UserThemeConsumer>
        {(theme) => (
          <StyledLockIconWrapper>
            <Icon name="lockFilledTiny" color={theme.greys.shade70} />
          </StyledLockIconWrapper>
        )}
      </UserThemeConsumer>
    );
  }

  if (team) {
    return <SettingsSearchDropdownTeamAccessory team={team} />;
  }

  return null;
}
